import React from "react";
import { InfoIcon } from "../membershipGuideIcons";
import { FEATURE_GROUPS } from "../membershipGuideConst";

const FeatureCard = ({ feature, alt }) => (
  <div className="feature">
    <div className={`feature-img${alt ? ` alt${alt}` : ""}`}>
      <img
        src={feature.img}
        alt={feature.title}
        className="feature-img-real"
        style={feature.imgPosition ? { objectPosition: feature.imgPosition } : undefined}
      />
    </div>
    <div className="feature-body">
      <div className="feature-tag">{feature.tag}</div>
      <h4>{feature.title}</h4>
      <p>{feature.desc}</p>
      {feature.note && <div className="feature-note">※ {feature.note}</div>}
    </div>
  </div>
);

const FeatureTextItem = ({ feature, index }) => (
  <div className="feature-text">
    <div className="feature-text-num">{String(index + 1).padStart(2, "0")}</div>
    <div className="feature-text-body">
      <div className="feature-tag">{feature.tag}</div>
      <h4>{feature.title}</h4>
      <p>{feature.desc}</p>
    </div>
  </div>
);

const FeatureGroup = ({ group }) => (
  <div className="feature-group">
    <div className="feature-group-head">
      <div className="gnum">{group.num}</div>
      <h3>{group.title}</h3>
    </div>
    {group.layout === "text" ? (
      <div className="features-text-grid">
        {group.features.map((f, i) => (
          <FeatureTextItem key={i} feature={f} index={i} />
        ))}
      </div>
    ) : (
      <div className={`features-grid${group.features.length === 2 ? " cols-2" : ""}`}>
        {group.features.map((f, i) => (
          <FeatureCard key={i} feature={f} alt={i === 1 ? 2 : i === 2 ? 3 : 0} />
        ))}
      </div>
    )}
  </div>
);

const OwnerNotice = () => (
  <div className="owner-notice">
    <div className="owner-notice-ic">
      <InfoIcon />
    </div>
    <div>
      <strong>소유주(개인) 광고는 지원되지 않습니다</strong>
      <p>
        디스코는 개업공인중개사 외 소유주(개인)가 광고할 수 있는 상품이 없습니다. 광고를 원하시면 매물
        지역에 노출 중인 공인중개사에게 직접 의뢰해 주세요.
      </p>
    </div>
  </div>
);

const Features = () => (
  <section className="section section-white" id="features">
    <div className="container">
      <div className="section-title-row">
        <h2>
          <span className="num">01</span> 주요 기능
        </h2>
      </div>
      {FEATURE_GROUPS.map((group) => (
        <FeatureGroup key={group.num} group={group} />
      ))}
      <OwnerNotice />
    </div>
  </section>
);

export default Features;
